'use es6';

import { Map as ImmutableMap, List } from 'immutable';
import RequestStatus from 'developer-docs-shared-components/lib/models/RequestStatus';
import { EndpointsActionTypes } from './actions';
const defaultState = new ImmutableMap({
  data: null,
  status: RequestStatus.uninitialized
});
export default function (state = defaultState, action) {
  switch (action.type) {
    case EndpointsActionTypes.FETCH_STARTED:
      return state.set('status', RequestStatus.pending);
    case EndpointsActionTypes.FETCH_SUCCEEDED:
      {
        return state.set('status', RequestStatus.succeeded).set('data', new List(action.payload));
      }
    case EndpointsActionTypes.FETCH_FAILED:
      return state.set('status', new RequestStatus({
        failed: true,
        errorDetails: action.payload.error
      }));
    default:
      return state;
  }
}